/* eslint-disable import/prefer-default-export */
import { wwtkReducer } from '../helpers';

/**
 * Action constants
 */
const SET_DONE_WWTK_ITEM = 'SET_DONE_WWTK_ITEM';

/**
 * Action creators
 */
const actions = {
  setWwtkDoneItem: (data) => ({ type: SET_DONE_WWTK_ITEM, data })
};

const setWwtkDoneItem = (id) => (dispatch) => dispatch(actions.setWwtkDoneItem(id));

export {
  setWwtkDoneItem
};
